'use client'

// Third-party Imports
import { SessionProvider } from 'next-auth/react'
import type { SessionProviderProps } from 'next-auth/react'

// HyperDX Imports
import { HyperDXUserSync } from '@/components/hyperdx/HyperDXUserSync'

// Umami Imports
import { UmamiUserSync } from '@/components/umami/UmamiUserSync'

export const NextAuthProvider = ({ children, ...rest }: SessionProviderProps) => {
  return (
    <SessionProvider {...rest}>
      <HyperDXUserSync />
      <UmamiUserSync />
      {children}
    </SessionProvider>
  )
}
